import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // Force dark mode always — no toggle, no localStorage dependency
  const [isDark] = useState(true);

  useEffect(() => {
    document.documentElement.classList.add('dark-mode');
    localStorage.setItem('garuda-theme', 'dark');
  }, []);

  const toggleTheme = () => {}; // Disabled — dark mode only

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
